import React from "react";
import { Form, Select } from "antd";
import "./styles.css";
import { getLabel } from "../../../hooks/use-labels";

const { Item } = Form;
const { Option } = Select;

const InputSelect = (props) => {
  const {
    id,
    mode,
    placeholder,
    name,
    label,
    required,
    value,
    formatId,
    disabled,
    options,
    metaKey,
    valueDetails,
    onChangeHandler,
  } = props;
  const selectProps = {
    ...(mode && { mode }),
    sise: "small",
    value: value || (mode === "tags" ? "" : []),
    onChange: (value, optionDetails) =>
      onChangeHandler(value, id, valueDetails && optionDetails),
  };
  return (
    <Item
      name={name}
      label={label}
      rules={[
        {
          required: required,
        },
      ]}
    >
      <Select
        {...selectProps}
        id={formatId(label)}
        placeholder={placeholder}
        disabled={disabled}
      >
        {options.length &&
          options.map((option, index) => (
            <Option value={option.value} key={option.key || index}>
              {metaKey
                ? getLabel(option[metaKey]) || option.label
                : option.label}
            </Option>
          ))}
      </Select>
    </Item>
  );
};

export default InputSelect;
